import React from "react";
import AdminLayout from "../layouts/AdminLayout";
import DeletionHistoryView from "../components/deletion-history/DeletionHistoryView";

const DeletionHistory = () => {
  return (
    <AdminLayout>
      <DeletionHistoryView />
    </AdminLayout>
  );
};

export default DeletionHistory;